import React from 'react';
import PropTypes from 'prop-types';
import { TablePagination } from '@material-ui/core';

import useStyles from './Paginator.styled';

const Paginator = ({
  component,
  limit,
  onPageChange,
  pagination,
  labelRowsPerPage,
  rowsPerPageOptions,
  onRowsPerPageChange,
  labelDisplayedRows,
  unknown_count = false,
}) => {
  const shouldShowChangeRow = rowsPerPageOptions && rowsPerPageOptions;
  const classes = useStyles();
  const default_count = unknown_count ? -1 : 1;

  return (
    <TablePagination
      data-cy='pagination'
      component={component}
      rowsPerPage={limit}
      classes={{
        root: classes.root,
        toolbar: !shouldShowChangeRow && classes.toolbar,
        menuItem: classes.menuItem,
        input: classes.input,
        selectRoot: !shouldShowChangeRow && classes.selectRoot,
        actions: classes.actions,
      }}
      onPageChange={onPageChange}
      count={pagination.totalRows || default_count}
      page={pagination.currentPage - 1 || 0}
      labelRowsPerPage={labelRowsPerPage}
      labelDisplayedRows={labelDisplayedRows}
      rowsPerPageOptions={rowsPerPageOptions}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  );
};

Paginator.propTypes = {
  component: PropTypes.string,
  limit: PropTypes.number,
  onPageChange: PropTypes.func,
  pagination: PropTypes.object,
  labelRowsPerPage: PropTypes.string,
  onRowsPerPageChange: PropTypes.func,
  labelDisplayedRows: PropTypes.func,
};

Paginator.defaultProps = {
  component: 'div',
  limit: 10,
  onPageChange: () => {},
  pagination: {
    totalRows: 1,
    currentPage: 0,
  },
};

export default Paginator;
